import { useCommunityJoinSearchParams } from '@/src/features/community/ui/hooks/useCommunityJoinSearchParams'
import { CommunityJoinCongratulationScreen } from '@/src/features/community/ui/screens/CommunityJoinCongratulationScreen'

const CommunityJoinCongratulationRouterPage = () => {
  const { idSlug, course, origin, source } = useCommunityJoinSearchParams()

  if (!idSlug) return null

  return <CommunityJoinCongratulationScreen idSlug={idSlug} course={course} origin={origin} source={source} />
}

export default CommunityJoinCongratulationRouterPage
